<template>
  <div>
    <slot>
      <form-validation
        :label="label"
        :id="identity"
        :name="name"
        :show="showValidation"
        :css-class="computedValidationCssClass"
        :validation="computedValidation"
        :error="error"
      ></form-validation>
    </slot>
    <div
      ref="captcha"
      class="captcha inline-block p-2 rounded bg-white border border-solid border-gray-300"
      :class="computedWrapperCssClass"
    ></div>
  </div>
</template>
<script>
import BaseInput from '@ssdcode/vue-form/src/components/Form/Inputs/BaseInput';
export default {
  name: 'Captcha',
  mixins: [BaseInput],
  data() {
    return {
      key: null,
      loads: 0,
      instanceId: null,
    };
  },
  created() {
    window.EventBus.listen('clear-form-' + this.group, this.reset);
    window.EventBus.listen('reset-form-' + this.group, this.reset);
  },
  mounted() {
    let key = document.head.querySelector('meta[name="captcha-site-key"]');
    this.key = (key || {}).content || null;
    if (!this.key) {
      this.clear();
      return;
    }
    this.loadCaptcha();
  },
  methods: {
    delayCaptcha() {
      this.loads = this.loads + 1;
      if (this.loads === 3) {
        return;
      }
      setTimeout(this.loadCaptcha, 1000);
    },
    loadCaptcha() {
      if (
        !window.hasOwnProperty('grecaptcha') ||
        !window.grecaptcha.hasOwnProperty('render')
      ) {
        this.delayCaptcha();
        return;
      }

      this.instanceId = window.grecaptcha.render(this.$refs.captcha, {
        sitekey: this.key,
        callback: this.verifyCallBack,
        'expired-callback': this.clear,
        'error-callback': this.failure,
      });
      this.clear();
      this.initialize();
      this.registerListeners();
    },
    verifyCallBack(token) {
      this.emit(token);
    },
    clear() {
      this.emit('');
    },
    reset() {
      window.grecaptcha.reset(this.instanceId);
      this.clear();
    },
    failure(error) {
      this.clear();
      console.log(error || 'Captcha script could not be loaded');
    },
  },
};
</script>
